<div class="flex column gap-8 main-section">
  <div mat-dialog-title class="header flex align-items-center">
    <h1 class="flex-auto">Organizational chart</h1>
    <mat-icon mat-dialog-close>close</mat-icon>
  </div>
  <div mat-dialog-content>
    <b3n-org-chart class="ignore-theme" [teamsData]="teamsData" [isLoading]="isLoading"></b3n-org-chart>
  </div>
</div>
